import { useWatch } from 'react-hook-form';

import { useProduct } from '@/entities/product';
import { TreatPoints } from '@/entities/treat-points';

export const LiveTreatPoints = () => {
    const { product } = useProduct();

    const quantity = useWatch({ name: 'quantity', defaultValue: 1, compute: (value: number) => value ?? 1 });

    if (!product?.sku || !product?.price) {
        return null;
    }

    return (
        <TreatPoints
            sku={product?.sku}
            quantity={quantity}
            guestTreatPoints={product?.guestTreatPoints}
            price={product?.price.sale ?? product?.price.original}
        />
    );
};
